import { urlFriendlyString } from "@/utils";
import type { RoutesData } from "@/utils/variables/routesData.types";

const locations = "locations";
const locationsMeters = `${locations}/meters/:energyType`;
const locationsMetersData = `${locationsMeters}/:meterNo/data`;

export const routesData: RoutesData = {
  locations: {
    key: urlFriendlyString(locations),
    path: locations,
  },
  locationsMeters: {
    key: urlFriendlyString(locationsMeters),
    path: locationsMeters,
  },
  locationsMetersData: {
    key: urlFriendlyString(locationsMetersData),
    path: locationsMetersData,
  },
};
